<script setup>
import { ref } from "vue";
import VModal from "@/Shared/VModal.vue";

const props = defineProps({
    events: Array,
    urlExport: String,
});

const emits = defineEmits(["onCancel"]);

const selectedEvent = ref(null);
const startDate = ref("");
const endDate = ref("");

const download = () => {
    if (!selectedEvent.value) return;

    const params = {};
    if (startDate.value) params.start_date = startDate.value;
    if (endDate.value) params.end_date = endDate.value;

    const url =
        props.urlExport.replace(":id", selectedEvent.value) +
        "?" +
        new URLSearchParams(params);
    window.open(url, "_blank");
};
</script>

<template>
    <VModal title="Export CSV" size="modal-lg" @onClose="emits('onCancel')">
        <template v-slot:body>
            <div class="row p-3">
                <div class="row align-items-sm-center mb-3">
                    <label
                        class="col-sm-3 label-size text-sm-end fw-bold mb-sm-0 mb-2"
                    >
                        Event
                        <span class="is-required">*</span>
                    </label>
                    <div class="col-sm-9">
                        <select class="form-select" v-model="selectedEvent">
                            <option value="" disabled selected>
                                Select Event
                            </option>
                            <option
                                v-for="event in events"
                                :key="event.id"
                                :value="event.id"
                            >
                                {{ event.description }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row align-items-sm-center mb-3">
                    <label
                        class="col-sm-3 label-size text-sm-end fw-bold mb-sm-0 mb-2"
                    >
                        Start Date
                    </label>
                    <div class="col-sm-9">
                        <input
                            type="date"
                            class="form-control"
                            v-model="startDate"
                        />
                    </div>
                </div>

                <div class="row align-items-sm-center mb-3">
                    <label
                        class="col-sm-3 label-size text-sm-end fw-bold mb-sm-0 mb-2"
                    >
                        End Date
                    </label>
                    <div class="col-sm-9">
                        <input
                            type="date"
                            class="form-control"
                            v-model="endDate"
                        />
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <button
                type="button"
                class="btn btn-secondary rounded-06"
                @click="emits('onCancel')"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn btn-success rounded-06"
                :disabled="!selectedEvent"
                @click="download"
            >
                <i class="fas fa-download me-1"></i> Download CSV
            </button>
        </template>
    </VModal>
</template>
